<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ on }">
        <v-btn @mousedown.stop v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="task.creator.id === user.id" class="action-btn" @click="openUpdateTaskDialog">
          <v-list-item-title>
            Chỉnh sửa
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="task.creator.id === user.id" class="action-btn" @click="openDeleteTaskDialog">
          <v-list-item-title>
            Xóa
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <UpdateTaskDialog ref="update-task-dialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import UpdateTaskDialog from './UpdateTaskDialog.vue'

export default {
  components: {
    UpdateTaskDialog
  },
  props: {
    task: { type: Object, default: () => {} }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  async created() {},
  methods: {
    ...mapActions('task', ['deleteTask']),
    openUpdateTaskDialog() {
      this.$refs['update-task-dialog'].openDialog(this.task.id)
    },
    openDeleteTaskDialog() {
      this.$dialog.confirm({
        title: 'Xóa công việc',
        text: ` Bạn có chắc chắn xóa công việc này ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          await this.deleteTask(this.task.id)
          this.$loading.active = false
        }
      })
    }
  }
}
</script>
<style scoped>
.action-btn {
  cursor: pointer;
}
.action-btn:hover {
  background-color: #f5f5f5;
}
</style>
